<template>
  <div>
        <v-container v-if="paymentLoading">
          <v-row>
              <v-col class="text-center m-4">
               {{ $t('loading-checkout')}}
              </v-col>
            </v-row>
            <v-row>
             <v-progress-linear
              color="primary"
              indeterminate
              reverse
            ></v-progress-linear>
          </v-row>
        </v-container>
        <v-container v-if="!paymentLoading">
          <v-row v-if="company">
            <v-col class="text-center">{{ company.companyName }} {{ $t('is-currently-on') }}: <strong>{{ companySubscription && companySubscription.type ? companySubscription.type : 'free'}} plan</strong></v-col>
          </v-row>
          <v-row v-if="!isAdmin">
            <v-col class="text-center">{{ $t('contact-admin') }}</v-col>
          </v-row>
          <template v-if="isAdmin">
            <v-row v-if="companySubscription">
              <v-col class="text-center">
                  <v-btn
                    color="primary"
                    @click="toCustomerPortal()"
                  >
                    {{ $t('manage-subscription') }}
                  </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="!companySubscription">
              <v-col 
                v-for="item in pricing"
                :key="item.id"
                >
                  <v-card
                    class="mx-auto"
                    max-width="344"
                  >
                    <v-card-title class="primary text--lighten">
                      <p class="text-h3">{{ item.name }}</p>
                    </v-card-title>
                    <v-spacer/>
                    <v-card-subtitle>
                      <p class="font-weight-bold text-center text-h2">{{ getPrice(item).amount }} {{ getPrice(item).currency }}</p>
                      <p class="font-weight-light text-uppercase text-center text-caption">{{ $t('per-month') }}</p>
                      <v-spacer />
                      <ul>
                        <li
                        v-for="(content, index) in item.content"
                        :key="'content-'+index"
                        >
                          {{ content }}
                        </li>
                      </ul>
                    </v-card-subtitle>

                    <v-card-actions class="justify-center">
                      <v-btn
                        color="primary"
                        @click="initCheckout(item)"
                      >
                        {{ $t('upgrade') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
             </v-row>
          </template>
        </v-container>
  </div>
</template>
<script>
  import { paymentService } from '@/services/PaymentService'
  export default {
    name: 'UpgradeAccount',
    props: {
      value: Boolean,
    },
    data () {
      return {
        paymentService: null,
        pricing: [],
        paymentLoading: false,
        
        pricingTable: [
          {
            stripeId: "prod_Hw44AdUFRe1t9Q",
            title: "Free",
            value: "0",
            active: false,
            perMonth: false,
            content: [
              "3 products",
              "1 document template",
              "1 workspace",
              "1 user",
            ],
          },
          {
            stripeId: "prod_HuaQz1wZkJtXHK",
            title: "Enhanced",
            value: "290",
            perMonth: true,
            content: [
              "30 products",
              "3 document templates",
              "2 workspaces",
              "3 users",
            ],
          },
          {
            stripeId: "prod_HuaTGA5Qni6i5P",
            title: "Ultimate",
            value: "490",
            perMonth: true,
            content: [
              "Unlimited products",
              "Unlimited document templates",
              "Unlimited workspaces",
              "Unlimited users",
            ],
          },
        ],
      }
    },
    created() {
      this.getPricing()
    },

    watch: {
      company: function(newVal) {
        if(!newVal) return;
        if(newVal.id && this.isAdmin) {
          this.$store.dispatch('company/fetchCompanyUsers', newVal.id)
        }
        if(newVal.country) {
          this.selectedCountry = {
            'countryName': newVal.country,
          }
        }
      },
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      user() {
        const res = this.$store.getters['user/getUser']
        this.setUserObject(res)
        return res
      },
      company() {
        const res = this.$store.getters['company/getCompany']
        return JSON.parse(JSON.stringify(res))
      },
      isAdmin () {
        return this.company && this.company.ownerId === this.user.id
      },
      companySubscription() {
        return this.$store.getters['company/getSubscription']
      },
    },
    methods: {
      async getPricing () {
        this.pricing = await paymentService.getPricing();
        this.pricing.forEach((item) => {
          item.content = this.getPricingContent(item)
        })
      },
      setUserObject (res) {
        this.userObject = JSON.parse(JSON.stringify(res));
      },
      getPrice (item) {
        if (!item.prices) return;
        const a = item.prices[0].unit_amount;
        return {
          'amount': (a-(a%100))/100,
          'currency': item.prices[0].currency
        }
      },
      getPricingContent (item) {
        return this.pricingTable.find((price) => price.stripeId === item.id).content;
      },
      initCheckout (item) {
        this.$emit('paymentLoading', 'true');
        this.paymentLoading = true;
        const priceId = item.prices[0].id
        paymentService.initCheckout(this.user.id, this.company.id, priceId, this.$route.fullPath)
      },
      toCustomerPortal () {
        this.paymentLoading = true;
        paymentService.toCustomerPortal();
      },
      onClose () {
        this.show = false;
      }
    }
  }
</script>

<style lang="sass">
  .v-snackbar--material
    margin-top: 32px
    margin-bottom: 32px

    .v-alert--material,
    .v-snack__wrapper
      border-radius: 4px

    .v-snack__content
      overflow: visible
      padding: 0
</style>
